import { Component, inject } from '@angular/core';
import { ProductI } from '@interfaces/custom-product';
import { AddToCartComponent } from '@spartacus/cart/base/components/add-to-cart';
import { map, Observable, startWith } from 'rxjs';
import { ClientLoggerService } from 'src/app/logger/client-logger.service';

@Component({
  selector: 'cx-add-to-cart',
  standalone: false,
  templateUrl: './custom-cx-add-to-cart.component.html',
  styleUrls: ['./custom-cx-add-to-cart.component.scss'],
})
export class CustomCxAddToCartComponent extends AddToCartComponent {

  logger = inject(ClientLoggerService);
  override addToCart(){
    this.logger.logUserAction('add_to_cart', {
      productCode: this.productCode,
    });
    console.log('CustomCxAddToCartComponent.addToCart()');
    super.addToCart();
  }
  product$ = this.currentProductService.getProduct() as unknown as Observable<ProductI>;

  futureStock$ = this.product$.pipe(
    map((product) => product?.futureStocks?.[0]),
    startWith(null),
  );

  futureStockLevel$ = this.product$.pipe(
    map((product) => product?.futureStocks?.[0]?.stock?.stockLevel ?? 0),
  );

  hasFutureStock$ = this.futureStockLevel$.pipe(
    map((stockLevel) => stockLevel > 0),
  );

  hasNoStock$ = this.product$.pipe(
    map((product) => product?.stock?.stockLevel === 0),
  );
}
